export default "__VITE_ASSET__9d8949e1__"